import { render, staticRenderFns } from "./RegOverviewPage.vue?vue&type=template&id=99351004&"
import script from "./RegOverviewPage.vue?vue&type=script&lang=js&"
export * from "./RegOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./RegOverviewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports